import { AiFillCloseCircle } from "react-icons/ai";
import { useAdmin } from "../../../../context/admin";
import Modal from "../../../common/Modal";
import AdminService from "../../../../services/admin.service";

export default function ConfirmDeleteTrip() {
    const {confirmDeleteTripId, setConfirmDeleteTripId} = useAdmin()
    async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        try {
            await AdminService.deleteTrip(confirmDeleteTripId!)
            window.location.reload()
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <Modal onSubmit={onSubmit}>
            <h1>Are you sure you want to delete this trip?</h1>
            <p>This action cannot be undone.</p>
            <div className="actions" style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
                <button style={{backgroundColor: 'red', color: 'white', border: 'none'}}
                >Delete</button>
                <button type="button" style={{backgroundColor: 'gray', color: 'white', border: 'none'}}
                onClick={() => setConfirmDeleteTripId(undefined)}
                >Cancel</button>
            </div>
            <div className="close" onClick={() => setConfirmDeleteTripId(undefined)}>
                <AiFillCloseCircle />
            </div>
        </Modal>
    )
}